export default __webpack_public_path__ + "static/media/seligmanKlein.73992cb7.jpg";